import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRepaymentDue } from '../../actions/EmiScheduleActions';
import styles from './index.module.scss';
import { Repayment } from '../../interfaces/Overview.type';
import KeyValueItem from 'src/components/KeyValueList/KeyValueItem';
import { formatAmount, getSanitizedEnumValue } from 'src/utils/commonUtils';
import SuspenseLoader from 'src/components/SkeletonLoader/SuspenseLoader';
import TableLoader from 'src/components/TableLoader/TableLoader';
import { PAYMENT_HISTORY_SECTION } from '../../constants/EmiSchedule.constant';
import { useParams } from 'react-router-dom';
import { RootState } from 'src/store';
import { createKey } from 'src/utils/CaseDetail.utils';
import Modal from '@cp/src/components/Modal/Modal';
import { PAYMENT_MODE } from '../../interfaces/RepaymentHistory.type';
import { dateFormat, DateFormat } from '@cp/src/utils/DateHelper';

const PaymentHistory = (props: { refId: string; isOpen: boolean; toggleOverlay: any }) => {
  const { refId, isOpen, toggleOverlay } = props;
  const { loanId = '', customerId = '' } = useParams();
  const dispatch = useDispatch();
  const repaymentDue = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.repaymentDue?.[refId]?.data
  );
  const loading = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.repaymentDue?.[refId]?.loading
  );
  const error = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.repaymentDue?.[refId]?.error
  );

  useEffect(() => {
    if (!repaymentDue && refId) {
      dispatch(getRepaymentDue(loanId, customerId, refId));
    }
  }, [refId]);

  useEffect(() => {
    if (error) toggleOverlay();
  }, [error]);

  const Sections = (payment: Repayment) => {
    return [
      {
        keyText: PAYMENT_HISTORY_SECTION.PAYMENT_AMOUNT,
        valueText: formatAmount(payment?.amount?.amount, false)
      },
      {
        keyText: PAYMENT_HISTORY_SECTION.PAID_ON,
        valueText: dateFormat(
          new Date(payment?.businessDate),
          DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME
        )
      },
      {
        keyText: PAYMENT_HISTORY_SECTION.PAYMENT_MODE,
        valueText: getSanitizedEnumValue(PAYMENT_MODE, payment?.paymentMode)
      }
    ];
  };

  const renderContent = useMemo(() => {
    return repaymentDue?.map((payment: any) => {
      return (
        <div key={payment.paymentReferenceId} className={styles['repaymentDueOverlay__items']}>
          {Sections(payment).map((item: any) => (
            <KeyValueItem
              key={item.keyText}
              {...item}
              itemClasses={styles['repaymentDueOverlay__items__item']}
            />
          ))}
        </div>
      );
    });
  }, [repaymentDue]);

  return (
    <div className={styles['repaymentDueHistory']}>
      <Modal
        visible={isOpen}
        onClose={toggleOverlay}
        header={'Payment history'}
        closeOnOutsideClick
      >
        <SuspenseLoader
          loading={!!loading}
          fallBack={<TableLoader numberOfLines={3} className={styles.paymentClass} />}
        >
          {renderContent}
        </SuspenseLoader>
      </Modal>
    </div>
  );
};

export default PaymentHistory;
